export default "__VITE_ASSET__DI4Pi8hh__"